import React from 'react'

// css
import 'assets/style/popup.scss'

// components
import { Header } from 'components'
import useModal from 'hook/useModal'
import { useRecoilValue } from 'recoil'
import { modalCountState } from 'store/atom/modal-state-atom'
import { formatNumberComma } from 'utils/format-util'

/**
 * Popup parameters
 * @children {Object}  - 바텀 시트 내부 dom
 * @list {Array}  - 선택 리스트가 있는 경우
 * @show {Boolean}  - [true | false]
 * @onCancel {Function}  - 부모에서 전달 받는 열림 닫힘 제어 함수
 */
function Element({ className = '', children, title = '', isShare = false, shareClick = () => {}, onClose = () => {} }) {
  const { closeModal } = useModal()
  const modalCount = useRecoilValue(modalCountState)

  return (
    <section className={`popup-wrap  show`}>
      <section className={`popup-window ` + className} style={{ height: '100%' }}>
        <section className="body">
          <Header
            title={`${title} ${modalCount ? '(' + formatNumberComma(modalCount) + ')' : ''}`}
            onClick={() => {
              onClose()
              closeModal()
            }}
            isShare={isShare}
            shareClick={shareClick}
          />
          {children}
        </section>
      </section>
    </section>
  )
}

export default Element
